import React from "react"
import useScript from "../../hooks/use-script"
import * as styles from "./script.module.scss"

type Props = {
  id: string
  src: string
  type: string
  async?: boolean
  cbid?: string
  blockingMode?: string
  display?: boolean
}

const Script: React.FC<Props> = ({
  id,
  src,
  type,
  async,
  cbid,
  blockingMode,
  display,
}) => {
  useScript(id, src, type, async, cbid, blockingMode)

  return <p id={id + "-script"} className={!display && styles.noDisplay}></p>
}

export default Script
